import React from "react";

const Select = ({data, className, onChangeSelect}) => {
  return (
    <select className={className} onChange={onChangeSelect} defaultValue="Seleccione una valor"> 
        {data.map((item, index) => (
            <option key={index} value={item.value}>{item.name}</option>
        ))}
    </select>
  );
};

export {Select};
